import { render, staticRenderFns } from "./SupTaskChangedNotifyIcon.vue?vue&type=template&id=0514710f&scoped=true&"
import script from "./SupTaskChangedNotifyIcon.vue?vue&type=script&lang=js&"
export * from "./SupTaskChangedNotifyIcon.vue?vue&type=script&lang=js&"
import style0 from "./SupTaskChangedNotifyIcon.vue?vue&type=style&index=0&id=0514710f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514710f",
  null
  
)

export default component.exports
import {QIcon,QBadge,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QBadge,QTooltip}, component.options.components || {})
